import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { useEffect, useRef } from 'preact/hooks';
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import SelectedFilters from "./SelectedFilters"

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
    const { loading, response: { products: { facets } } = {} } = useAppState();
    const { updateSearch } = useActions();
    const mobilePanelRef = useRef(null);

    useEffect(() => {
        if(window.innerWidth >= 750 || !mobilePanelRef.current) return;
        if(sidebarOpen) {
            mobilePanelRef.current.classList.add('menu-opening');
            mobilePanelRef.current.setAttribute('open', '');
        } else {
            mobilePanelRef.current.classList.remove('menu-opening');
            setTimeout(() => {
                mobilePanelRef.current.removeAttribute('open');
            }, 200)
        }
    }, [ sidebarOpen ])

    return facets?.length > 0 ? (
        <aside
            id="ns-filters"
            class="facets-wrapper"
            aria-labelledby="verticalTitle"
        >
            {/* Mobile */}
            <div class="facets-container scroll-trigger animate--fade-in">
                <div class="mobile-facets__wrapper medium-hide large-up-hide">
                    <details 
                        class="mobile-facets__disclosure disclosure-has-popup"
                        ref={mobilePanelRef}
                    >
                        <summary 
                            class="mobile-facets__open-wrapper focus-offset"
                            aria-expanded={sidebarOpen}
                            onClick={(e) => {
                                e.preventDefault();
                                toggleSidebar();
                            }}
                        >
                            <span className="mobile-facets__open">
                                <svg class="icon icon-filter" aria-hidden="true" focusable="false" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.567 9.643a.339.339 0 0 1-.346-.346.339.339 0 0 1 .345-.351h5.565c.098 0 .181.034.25.102.067.068.101.151.101.25a.332.332 0 0 1-.102.243.339.339 0 0 1-.249.102H3.567ZM2.31 6.784a.339.339 0 0 1-.351-.345c0-.098.034-.181.102-.25a.339.339 0 0 1 .249-.101h8.084c.094 0 .175.034.243.102a.339.339 0 0 1 .102.249.339.339 0 0 1-.345.345H2.31ZM1.025 3.925A.339.339 0 0 1 .68 3.58c0-.098.034-.181.102-.25a.332.332 0 0 1 .243-.101h10.631c.094 0 .175.034.243.102.068.068.102.15.102.249a.339.339 0 0 1-.345.345H1.025Z" fill="currentColor"></path>
                                </svg>
                                <span class="mobile-facets__open-label button-label medium-hide large-up-hide">
                                    Agregar filtro
                                </span>
                                <span class="mobile-facets__open-label button-label small-hide">
                                    Filtrar
                                </span>
                            </span>
                            <span class="mobile-facets__close mobile-facets__close--no-js" tabIndex={0}> 
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                                </svg>
                            </span>
                        </summary>

                        <div class="mobile-facets">
                            <div class="mobile-facets__inner gradient">
                                {/* Header */}
                                <div class="mobile-facets__header">
                                    <div class="mobile-facets__header-inner">
                                        <h2 class="mobile-facets__heading medium-hide large-up-hide">Filtrar</h2>
                                        <h2 class="mobile-facets__heading small-hide">Filtrar</h2>
                                    </div>
                                </div>

                                <div class="mobile-facets__main gradient">
                                    {/* Content */}
                                    <div class="ns-filters-mobile">
                                        <div id="ns-facets-container">
                                            <div class="facets">
                                                <div class="facets__form-vertical">
                                                    <div>
                                                        <SelectedFilters />
                                                        {facets?.map(facet => {
                                                            switch (facet.type) {
                                                                case "terms":
                                                                    return <Facet key={facet.id} facet={facet} />
                                                                case "stats":
                                                                    return <RangeFacet key={facet.id} facet={facet} />
                                                                default:
                                                                    return null
                                                            }
                                                        })}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="small-hide"></div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div class="mobile-facets__footer">
                                        <button
                                            type="button" 
                                            class="no-js-hidden button button--secondary button--full-width"
                                            onClick={toggleSidebar}
                                        >
                                            Aplicar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </details>
                </div>
            </div>

            {/* Desktop */}
            <div id="ns-desktop-facets-container">
                <div class="facets">
                    <div class="facets__form-vertical">
                        <div>
                            <SelectedFilters />
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    ) : ( null )
}
